export const LEGAL_PAGES = {
    privacy: {
        title: "Privacy Policy",
        updated: "Last updated: July 2026",
        intro:
            "This Privacy Policy explains how PISI LIMITED collects, uses and protects personal information provided through this website.",
        sections: [
            {
                heading: "Who We Are",
                body: "PISI LIMITED is a UK-based wholesale and retail business located at 5 Cotelands, Croydon, CR0 5UD, United Kingdom. You can contact us by email at pisilimitedhello@gmail.com or by phone on 07438989869.",
            },
            {
                heading: "Information We Collect",
                body: "When you submit an enquiry through our contact form, we collect the information you provide, which may include your full name, business name, email address, phone number, enquiry type and the contents of your message. We do not collect payment information through this website.",
            },
            {
                heading: "How We Use Your Information",
                body: "We use the information you provide solely to respond to your enquiry, discuss product or wholesale requirements, and manage our business relationship with you. We do not use your details for unrelated marketing without your consent.",
            },
            {
                heading: "How We Store and Protect Your Information",
                body: "Enquiry information is stored securely and is only accessible to those who need it to respond to your request. We retain enquiry records only for as long as is reasonably necessary to handle your enquiry and maintain appropriate business records.",
            },
            {
                heading: "Sharing Your Information",
                body: "We do not sell, trade or rent your personal information to third parties. Information is only shared where necessary to fulfil your enquiry or where we are required to do so by law.",
            },
            {
                heading: "Your Rights",
                body: "Under UK data protection law, you have the right to request access to the personal information we hold about you, to request its correction or deletion, and to object to or restrict certain processing. To exercise any of these rights, please contact us using the details above.",
            },
            {
                heading: "Changes to This Policy",
                body: "We may update this Privacy Policy from time to time. Any changes will be posted on this page with an updated revision date.",
            },
        ],
    },
    terms: {
        title: "Terms & Conditions",
        updated: "Last updated: July 2026",
        intro:
            "These Terms & Conditions govern the use of the PISI LIMITED website and set out the general basis on which we handle enquiries and business communications.",
        sections: [
            {
                heading: "About These Terms",
                body: "This website is operated by PISI LIMITED, 5 Cotelands, Croydon, CR0 5UD, United Kingdom. By using this website, you accept these terms. If you do not agree with them, please do not use this website.",
            },
            {
                heading: "Enquiries and Orders",
                body: "Submitting an enquiry through this website does not constitute an order or a binding agreement. Any supply of products is subject to separate discussion, confirmation and agreement between you and PISI LIMITED.",
            },
            {
                heading: "Product Information",
                body: "Product categories shown on this website are provided for general information only and do not represent a complete or guaranteed list of available stock. Availability, specifications and pricing are confirmed during the enquiry process.",
            },
            {
                heading: "Website Content",
                body: "All content on this website, including text and design, belongs to PISI LIMITED unless otherwise stated. You may not reproduce or reuse this content without our prior written permission.",
            },
            {
                heading: "Liability",
                body: "We take reasonable care to keep the information on this website accurate and up to date, but we make no warranties or guarantees about its completeness or accuracy. Nothing in these terms excludes or limits liability where it would be unlawful to do so.",
            },
            {
                heading: "Governing Law",
                body: "These terms are governed by the laws of England and Wales, and any disputes arising from the use of this website will be subject to the jurisdiction of the courts of England and Wales.",
            },
            {
                heading: "Contact",
                body: "If you have any questions about these Terms & Conditions, please contact us at pisilimitedhello@gmail.com or on 07438989869.",
            },
        ],
    },
    cookies: {
        title: "Cookie Policy",
        updated: "Last updated: July 2026",
        intro:
            "This Cookie Policy explains how PISI LIMITED uses cookies and similar technologies on this website.",
        sections: [
            {
                heading: "What Are Cookies",
                body: "Cookies are small text files placed on your device when you visit a website. They are widely used to make websites work efficiently and to provide information to website owners.",
            },
            {
                heading: "How We Use Cookies",
                body: "This website uses a small number of cookies to ensure the site functions correctly and to help us understand how visitors use the site, so we can improve its performance and content.",
            },
            {
                heading: "Types of Cookies We Use",
                body: "Essential cookies enable core site functionality such as page navigation and form submission. Analytics cookies collect anonymous information about how the site is used, such as pages visited and time spent on the site.",
            },
            {
                heading: "Managing Cookies",
                body: "Most web browsers allow you to control cookies through their settings, including blocking or deleting them. Please note that restricting essential cookies may affect how this website functions.",
            },
            {
                heading: "Changes to This Policy",
                body: "We may update this Cookie Policy from time to time. Any changes will be posted on this page with an updated revision date.",
            },
            {
                heading: "Contact",
                body: "If you have any questions about our use of cookies, please contact us at pisilimitedhello@gmail.com or on 07438989869.",
            },
        ],
    },
};
